import { Base } from '@studiometa/js-toolkit';

/**
 * Homepage class.
 */
export default class Readmore extends Base {
  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'Readmore',
    refs: ['btn', 'content', 'firstContent'],
    emits: ['open-panel'],
    options: {
      labelClose: {
        type: String,
        default: 'Close ↑',
      },
      labelOpen: {
        type: String,
        default: 'Read more ↓',
      },
    },
  };

  /**
   * On btn click
   * @returns {void}
   */
  onClick() {
    if (this.open) {
      this.$el.innerHTML = this.$options.labelClose;
    } else {
      this.$el.innerHTML = this.$options.labelOpen;
    }

    this.$emit('open-panel');
  }
}
